module.exports = __webpack_public_path__ + "images/navbar/airc-back.ddccf1a728368e796e27a57d7f3727b9.png";